interface Listener {
  (enabled: boolean): void;
}

class WorkspaceNavigationEnabled {
  enabled: boolean;
  listeners: Set<Listener> = new Set();

  constructor(initialValue?: boolean) {
    this.enabled = initialValue || false;
  }

  setValue(nextValue: boolean): void {
    this.enabled = nextValue;

    for (const listener of this.listeners) {
      listener(this.enabled);
    }
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);

    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const workspaceNavigationEnabled = new WorkspaceNavigationEnabled();
